import HomeTopbar from "../homepage/components/HomeTopbar";
import commonBtnBack from "../assets/images/commonbtn/common_btn_back.png";
import commonBtnBack2x from "../assets/images/commonbtn/common_btn_back@2x.png";
import commonBtnBackHover from "../assets/images/commonbtn/common_btn_back_hover.png";
import commonBtnBackHover2x from "../assets/images/commonbtn/common_btn_back_hover@2x.png";
import "../homepage/HomePage.css";

export default function LegalLayout({title, showDates = true, wideContent = false, isMusicOn, onMusicToggle, mobile = false, children}) {
    const containerClassName = wideContent ? "legal-container legal-container--wide" : "legal-container";

    if (mobile) {
        return (
            <div className="mobile-legal-page">
                <header className="mobile-legal-header">
                    <a href="#/" aria-label="返回首页">返回</a>
                    <h1>{title}</h1>
                </header>
                <nav className="mobile-legal-nav" aria-label="协议导航">
                    <a href="#/user-agreement">用户协议</a>
                    <a href="#/privacy-policy">隐私协议</a>
                    <a href="#/contact-us">联系我们</a>
                </nav>
                <main className="mobile-legal-content">{children}</main>
            </div>
        );
    }

    return (
        <div className="wraps legal-page news_bg">
            <HomeTopbar
                activeNavId="home"
                isMusicOn={isMusicOn}
                onMusicToggle={onMusicToggle}
                reserveHref="#reservation"
                reserveClassName="legal-nav-reserve-link"
                logoHref="#home"
            />
            <main className="legal-main">
                <div className={containerClassName}>
                    <h1 className="legal-title">{title}</h1>
                    <div className="legal-title-line" aria-hidden="true"></div>
                    {showDates ? (
                        <div className="legal-meta" aria-label="页面信息">
                            <>
                                <p>更新日期：2026年07月09日</p>
                                <p>生效日期：2026年07月09日</p>
                            </>
                        </div>
                    ) : null}
                    <article className="legal-content">{children}</article>
                    <a className="legal-back-home" href="#home" aria-label="返回主页">
                        <picture>
                            <source media="(min-width: 1921px)" srcSet={commonBtnBack2x}/>
                            <img className="default" src={commonBtnBack} alt="" aria-hidden="true"/>
                        </picture>
                        <picture>
                            <source media="(min-width: 1921px)" srcSet={commonBtnBackHover2x}/>
                            <img className="active" src={commonBtnBackHover} alt="" aria-hidden="true"/>
                        </picture>
                    </a>
                </div>
            </main>
        </div>
    );
}
